import { EqxLink as Link } from '@equinoxx/react'
import React from 'react'
import { useEqxContinuumLayoutContext } from './EqxContinuumLayout'

interface EqxContinuumNavPageActionItemProps {
    title: string
    link: string
    dropdown?: boolean
    children?: React.ReactNode
    colour?: string //bootstrap colour class like success/danger etc
    onClick?: React.MouseEventHandler<HTMLAnchorElement>
    icon?: string
}
const EqxContinuumNavPageActionItem = (props: EqxContinuumNavPageActionItemProps) => {
    return (
        <Link
            title={props.title}
            to={props.link}
            onClick={props.onClick}
            className={
                'btn btn-' +
                (props.colour ?? 'primary') +
                ' btn-sm btn-asset-overview ' +
                (props.dropdown ? 'dropdown-toggle' : '')
            }
        >
            <span className={props.icon + ' page-action-icon'}></span>{' '}
            <span className="d-none d-md-inline">{props.title}</span>
            {props.children}
        </Link>
    )
}
interface EqxContinuumNavProps {
    children?: React.ReactNode
    pageTitle: string | React.ReactNode
    pageActions?: React.ReactNode
}
const EqxContinuumNav = (props: EqxContinuumNavProps) => {
    const context = useEqxContinuumLayoutContext()
    return (
        <nav id="main">
            <a href="#" id="nav-menu-btn" onClick={() => context.setShowSidebar(!context.showSidebar)}>
                <span className="fas fa-bars"></span>
            </a>
            <h1 id="nav-title" className="display-1 text-truncate" title={props.pageTitle?.toString()}>
                {props.pageTitle}
            </h1>
            <div id="nav-page-actions">{props.pageActions}</div>
        </nav>
    )
}
export { EqxContinuumNav as default, EqxContinuumNavPageActionItem }

